import { BindingError } from "../../BindingError.js";
class Schema {
  constructor(store) {
    this.store = store;
  }
  getEnumValues(enumName) {
    return Array.from(this.store.enums.get(enumName) ?? this.throwError(`Missing schema for enum ${enumName}`));
  }
  getEntityOrUndefined(entityName) {
    return this.store.entities.get(entityName);
  }
  getEntityNames() {
    return Array.from(this.store.entities.keys());
  }
  getEntity(entityName) {
    return this.getEntityOrUndefined(entityName) ?? this.throwError(`Missing schema for entity ${entityName}`);
  }
  getEntityFieldOrUndefined(entityName, fieldName) {
    return this.store.entities.get(entityName)?.fields.get(fieldName);
  }
  getEntityField(entityName, fieldName) {
    return this.getEntityFieldOrUndefined(entityName, fieldName) ?? this.throwError(`Missing schema for field ${entityName}.${fieldName}`);
  }
  getEntityColumn(entityName, fieldName) {
    const field = this.getEntityField(entityName, fieldName);
    return field.__typename === "_Column" ? field : this.throwError(`Field ${entityName}.${fieldName} is not of type column`);
  }
  getEntityRelation(entityName, fieldName) {
    const field = this.getEntityField(entityName, fieldName);
    return field.__typename === "_Relation" ? field : this.throwError(`Field ${entityName}.${fieldName} is not of type relation`);
  }
  throwError(message) {
    throw new BindingError(message);
  }
}
export {
  Schema
};
//# sourceMappingURL=Schema.js.map
